import React, { Fragment, useState, useEffect } from "react";
import Editor from '../../modules/form/cwysiwyg'
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from './settings';
import Typography from '@material-ui/core/Typography';

export default function (props) {
    const { value, handleFieldValue, multiline, extraProps, rowsMax, shareProps, error, required, tooltip, contexthelp, changefieldto, FieldIsSpellCheck, ...otherProps } = props
    const { label, helperText, name, xtype, fullWidth, ...otherConfigs } = otherProps;
    let tlabel = <Typography variant='subtitle2' color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
    {tooltip && <Tooltip title={tooltip ? tooltip : null}
        placement="bottom-start" >
        <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
            onClick={(evt) => contexthelp ?
                DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
    </Tooltip>}
</Typography>

    return (
        <Editor handleFieldChange = {handleFieldValue} name={name}  edit={true} value={value} label={tlabel}/>
    )
}